export function MetricCard({ icon: Icon, label, value, hint, testId, theme = "stone", onClick }) {
  const THEMES = {
    emerald: {
      bg: "bg-emerald-50",
      border: "border-emerald-200/70",
      hover: "hover:bg-emerald-100/80 hover:border-emerald-300",
      icon: "bg-emerald-600 text-white",
      label: "text-emerald-800",
      value: "text-emerald-950",
      hint: "text-emerald-700/80",
      ring: "focus-visible:ring-emerald-400",
    },
    teal: {
      bg: "bg-teal-50",
      border: "border-teal-200/70",
      hover: "hover:bg-teal-100/80 hover:border-teal-300",
      icon: "bg-teal-600 text-white",
      label: "text-teal-800",
      value: "text-teal-950",
      hint: "text-teal-700/80",
      ring: "focus-visible:ring-teal-400",
    },
    amber: {
      bg: "bg-amber-50",
      border: "border-amber-200/70",
      hover: "hover:bg-amber-100/80 hover:border-amber-300",
      icon: "bg-amber-600 text-white",
      label: "text-amber-800",
      value: "text-amber-950",
      hint: "text-amber-700/80",
      ring: "focus-visible:ring-amber-400",
    },
    rose: {
      bg: "bg-rose-50",
      border: "border-rose-200/70",
      hover: "hover:bg-rose-100/80 hover:border-rose-300",
      icon: "bg-rose-600 text-white",
      label: "text-rose-800",
      value: "text-rose-950",
      hint: "text-rose-700/80",
      ring: "focus-visible:ring-rose-400",
    },
    sky: {
      bg: "bg-sky-50",
      border: "border-sky-200/70",
      hover: "hover:bg-sky-100/80 hover:border-sky-300",
      icon: "bg-sky-600 text-white",
      label: "text-sky-800",
      value: "text-sky-950",
      hint: "text-sky-700/80",
      ring: "focus-visible:ring-sky-400",
    },
    stone: {
      bg: "bg-white",
      border: "border-stone-200",
      hover: "hover:bg-stone-50 hover:border-stone-300",
      icon: "bg-stone-100 text-stone-600",
      label: "text-stone-500",
      value: "text-stone-900",
      hint: "text-stone-500",
      ring: "focus-visible:ring-stone-400",
    },
  };

  const t = THEMES[theme] || THEMES.stone;
  const isInteractive = typeof onClick === "function";
  const Tag = isInteractive ? "button" : "div";

  return (
    <Tag
      type={isInteractive ? "button" : undefined}
      onClick={onClick}
      data-testid={testId}
      className={`text-left w-full rounded-2xl border p-6 transition-all flex flex-col justify-between h-full
        ${t.bg} ${t.border}
        ${isInteractive ? `${t.hover} cursor-pointer hover:-translate-y-0.5 hover:shadow-md
           focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${t.ring}` : ""}
      `}
    >
      <div className="flex items-start justify-between gap-3">
        <div className={`text-[11px] font-semibold uppercase tracking-[0.18em] ${t.label}`}>
          {label}
        </div>
        {Icon && (
          <div className={`p-2.5 rounded-xl shadow-sm ${t.icon}`}>
            <Icon size={16} strokeWidth={1.75} />
          </div>
        )}
      </div>
      <div className="mt-6">
        <div className={`font-display text-4xl sm:text-5xl font-light tracking-tighter tabular-nums ${t.value}`}>
          {value}
        </div>
        {hint && <div className={`text-xs mt-2 ${t.hint}`}>{hint}</div>}
      </div>
    </Tag>
  );
}
